import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";

/** A token-styled menu, shared by curriculum and study configuration. */
export function BrandedSelect({
  value,
  onValueChange,
  options,
  label,
  id,
  className,
  disabled,
  name,
  required,
}: {
  value: string;
  onValueChange: (value: string) => void;
  options: { value: string; label: string; disabled?: boolean }[];
  label: string;
  id?: string;
  className?: string;
  disabled?: boolean;
  name?: string;
  required?: boolean;
}) {
  const empty = "__novari_empty_selection__";
  return (
    <Select
      value={value || empty}
      onValueChange={(next) => onValueChange(next === empty ? "" : next)}
      disabled={disabled}
      name={name}
      required={required}
      // Radix keeps a hidden native <select>; without this Chrome offers its address autofill list over our menu.
      autoComplete="off"
    >
      <SelectTrigger id={id} aria-label={label} className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value || empty}
            disabled={option.disabled}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
